var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpResumeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7 0C3.136 0 0 3.136 0 7C0 10.864 3.136 14 7 14C10.864 14 14 10.864 14 7C14 3.136 10.864 0 7 0ZM7.7 11.9H6.3V10.5H7.7V11.9ZM9.149 6.475L8.519 7.119C8.169 7.476 7.917 7.798 7.791 8.302C7.735 8.526 7.7 8.778 7.7 9.1H6.3V8.75C6.3 8.428 6.356 8.12 6.454 7.833C6.594 7.427 6.825 7.063 7.119 6.769L7.987 5.887C8.309 5.579 8.463 5.117 8.372 4.627C8.281 4.123 7.889 3.696 7.399 3.556C6.622 3.339 5.901 3.78 5.67 4.445C5.586 4.704 5.369 4.9 5.096 4.9H4.886C4.48 4.9 4.2 4.508 4.312 4.116C4.613 3.087 5.488 2.303 6.573 2.135C7.637 1.967 8.652 2.52 9.282 3.395C10.108 4.536 9.863 5.761 9.149 6.475Z",
    fill: "#30B36B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpResumeIcon);
export default __webpack_public_path__ + "static/media/help-resume-icon.f6e37805fd9c23581d2f7ff787b5bdca.svg";
export { ForwardRef as ReactComponent };